import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/remote-config";

const config = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
  authDomain: `${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}`,
  databaseURL: `${process.env.REACT_APP_FIREBASE_DATABASE_URL}`,
  projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
  storageBucket: `${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`,
  messagingSenderId: `${process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID}`,
  appId: `${process.env.REACT_APP_FIREBASE_APP_ID}`,
  measurementId: `${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`,
};

const fire = firebase.initializeApp(config);

// The default and recommended production fetch interval for Remote Config is 12 hours
// Setting below should be used for development only
fire.remoteConfig().settings.minimumFetchIntervalMillis =
  +`${process.env.REACT_APP_FIREBASE_REMOTE_FETCH_INTERVAL_MILLIS}`;

fire.remoteConfig().defaultConfig = {
  correct_answer_description: "Ödülün cüzdanına yüklendi.",
  correct_answer_description_bayram: "Ödülün cüzdanına yüklendi.",
  correct_answer_extra_popup_first_text:
    "Doğru cevap!👏 <br/>Ödülün cüzdana yüklendi.",
  correct_answer_extra_popup_first_title: "TEBRİKLER! 2 GB KAZANDIN!",
  correct_answer_extra_popup_second_button: "YENİ SORU",
  correct_answer_extra_popup_second_text:
    "Toplamda 3 soru cevapladığın için<br/>cüzdana EKSTRA 1 GB daha yüklendi!🎁 ",
  correct_answer_extra_popup_second_title: "3 ALDIN 1 BEDAVA KAZANDIN!",
  correct_answer_extra_reward_description: "Ödülün cüzdanına yüklendi.",
  correct_answer_header: "Doğru Cevap!",
  correct_answer_popup_button: "YENİ SORU",
  correct_answer_popup_main_title:
    '<span class="black-text">TEBRİKLER!</span><br/>2 GB',
  correct_answer_popup_text:
    "Doğru cevap! 👏 <br/>Ödülün cüzdana yüklendi. <br/>Hadi yeni soru cevapla, kazanmaya doyma! 🏆",
  correct_answer_popup_title: " KAZANDIN!",
  error_popup_button: "Tamam",
  error_popup_text:
    "İşlemine devam edemiyoruz.<br/>Lütfen daha sonra tekrar dene.",
  error_popup_title: "Tüh! Bir sorunla karşılaştık! 😔",
  new_question_button: "KAZANMAYA DEVAM ET",
  no_stamp_text: "3 alana 1 BEDAVA!",
  no_stamp_title:
    'Doğruysa <span class="yellow-text">2 GB</span>, yanlışsa <span class="yellow-text">1 GB<br/>KAZAN!</span>',
  one_stamp_last_day_text: "Süre bitmeden 2 alana 1 BEDAVA!",
  one_stamp_last_day_title:
    'Doğruysa <span class="yellow-text">2 GB</span>, yanlışsa <span class="yellow-text">1 GB<br/>KAZAN!</span>',
  one_stamp_text: "Süre bitmeden 2 alana 1 BEDAVA!",
  one_stamp_title:
    'Doğruysa <span class="yellow-text">2 GB</span>, yanlışsa <span class="yellow-text">1 GB<br/>KAZAN!</span>',
  payment_error_button: "Tekrar dene",
  payment_fail_message_button: "Tekrar dene",
  payment_fail_message_for_code_2803:
    "Beklenmeyen bir sorun oluştu, lütfen daha sonra tekrar dene.",
  payment_fail_message_for_code_header_2803: "Ödemeni alamadık 😔",
  two_stamp_last_day_text: "Süre bitmeden 1 alana 1 BEDAVA!",
  two_stamp_last_day_title:
    'Doğruysa <span class="yellow-text">2 GB</span>, yanlışsa <span class="yellow-text">1 GB<br/>KAZAN!</span>',
  two_stamp_text: "Süre bitmeden 1 alana 1 BEDAVA!",
  two_stamp_title:
    'Doğruysa <span class="yellow-text">2 GB</span>, yanlışsa <span class="yellow-text">1 GB<br/>KAZAN!</span>',
  weekly_win_stamp:
    "https://yaani.tcellcdn.net/kazankazan/weekly-win-stamp.svg",
  wrong_answer_description: "Ödülün cüzdanına yüklendi.",
  wrong_answer_description_bayram: "Ödülün cüzdanına yüklendi.",
  wrong_answer_extra_popup_button: "YENİ SORU",
  wrong_answer_extra_popup_first_text:
    "Yanlış cevap😞 <br/>Teselli ödülün cüzdana yüklendi.",
  wrong_answer_extra_popup_first_title: "1 GB TESELLİ ÖDÜLÜ KAZANDIN!",
  wrong_answer_extra_popup_second_text:
    "Toplamda 3 soru cevapladığın için<br/>cüzdana EKSTRA 1 GB yüklendi!🎁 ",
  wrong_answer_extra_popup_second_title: "3 ALDIN 1 BEDAVA KAZANDIN!",
  wrong_answer_extra_reward_description: "Ödülün cüzdanına yüklendi.",
  wrong_answer_header: "Yanlış Cevap!",
  wrong_answer_popup_button: "YENİ SORU",
  wrong_answer_popup_main_title: "1 GB",
  wrong_answer_popup_text:
    "Yanlış cevap😞 <br/>Ama üzülme, teselli ödülün cüzdana yüklendi. <br/>Hadi yeni soru cevapla, kazanmaya doyma! 🏆",
  wrong_answer_popup_title: "TESELLİ ÖDÜLÜ<br/>KAZANDIN!",
};

export default fire;
